<template>
	<div class="header">
		<span class="h1">
			GitHub Desktop for Humanities
		</span>
	</div>
</template>

<script>
	export default {
		name: "vHeader"
	}
</script>

<style scoped>
 .header {
	 display: flex;
	 align-items: center;
 }
	.header>* {
		height: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/vHeader.vue